export const TEMPLATE_VARIABLE_GROUPS = [
  {
    title: 'Outreach & reminders',
    description: 'Initial outreach, follow-ups, and reminder emails',
    variables: [
      { label: 'First Name', value: '{first_name}' },
      { label: 'Username', value: '{username}' },
      { label: 'Contact Person', value: '{contact_person}' },
    ],
  },
  {
    title: 'Barterdeals',
    description: 'Briefing, ordered reminders, and barterdeal automation',
    variables: [
      { label: 'Voucher Code', value: '{vouchercode}' },
      { label: 'Discount Code', value: '{discount_code}' },
      { label: 'Signature', value: '{signature}' },
    ],
  },
];

export const TEMPLATE_VARIABLES = TEMPLATE_VARIABLE_GROUPS.flatMap(
  (group) => group.variables
);
